/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Action_ErrorInputs */

const cs_ebr_action_error = /** @type {(inputs: Ebr_Action_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chyby`)
};

const en_ebr_action_error = /** @type {(inputs: Ebr_Action_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errors`)
};

/**
* | output |
* | --- |
* | "Errors" |
*
* @param {Ebr_Action_ErrorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_action_error = /** @type {((inputs?: Ebr_Action_ErrorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Action_ErrorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_action_error(inputs)
	return cs_ebr_action_error(inputs)
});